<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><i class="fa fa-exclamation-triangle"></i> <span v-html="options.title"></span></h4>
                </div>
                <div class="modal-body">
                    <p class="confirmation-template"></p>
                </div>
                <div class="modal-footer">
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="confirm" autofocus>{{options.confirm}}</button>
                    </div>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<script>
    let Vue = require('vue/dist/vue.js');

    export default {
        name: 'confirmation-modal',
        data() {
            return {
                confirm_callback: null,
                options: {},
                vm : null,
                showing: false,
            };
        },
        methods: {
            hide(e) {
                if(this.showing)
                {
                    this.cancel();
                }
            },
            confirm() {
                if(this.confirm_callback !== null)
                    this.confirm_callback();
                this.showing = false;
            },
            cancel() {
                if(this.cancel_callback !== null)
                    this.cancel_callback();
                this.showing = false;
            },
            open(args)
            {
                this.showing = true;

                this.options = {
                    title: "Alert",
                    message: "Alert Message",
                    confirm: "OK",
                    data: {}
                };

                for(let i in this.options)
                {
                    if(this.options.hasOwnProperty(i))
                    {
                        if(typeof args.options != 'undefined' && typeof args.options[i] != 'undefined')
                        {
                            this.options[i] = args.options[i];
                        }
                    }
                }

                if(typeof args.confirm_callback != 'undefined')
                {
                    this.confirm_callback = args.confirm_callback;
                }

                this.$nextTick(() => {
                    if(this.vm !== null)
                    {
                        this.vm.$destroy();

                        $(this.vm.$el).remove();
                    }

                    let el = $('<div>');
                    $(this.$el).find('.confirmation-template').append(el);

                    this.vm = new Vue({
                        functional: true,
                        template: '<div>' + this.options.message + '</div>',
                        data: this.options.data,
                    }).$mount(el.get()[0]);
                });

                $(this.$el).modal('show');
            },
            shown() {
                $(this.$el).find("[autofocus]").focus();
            }
        },
        mounted() {
            this.$root.bus.$on('alert-modal:open', this.open);
            $(this.$el).modal({show:false, backdrop: 'static'});
            $(this.$el).on('hide.bs.modal', this.hide);
            $(this.$el).on('shown.bs.modal', this.shown);
        }
    }
</script>

<style>

</style>